export default [
  {name: 'Default', style: 'mapbox://styles/mapbox/streets-v10'},
  {name: 'Satellite', style: 'mapbox://styles/mapbox/satellite-streets-v11'},
]
